import Swiper from 'swiper/swiper-bundle';
// import 'swiper/swiper-bundle.min.css';
export function slider() {

    const mainSlides = document.querySelectorAll('.j-fvSlider .swiper-slide');

    let mySwiper = new Swiper('.j-fvSlider', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // loopAdditionalSlides: 0,
        loopAdditionalSlides: 1,
        preventInteractionOnTransition: true,
        loopPreventsSlide: false,
        speed: 1000,
        draggable: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            798: {
                spaceBetween: 64,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'bullets',
                    // 個別にクラスをつけることができる
                    renderBullet: (index, className) => {
                        return '<span class="' + className + '">0' + (Number(index) + 1) + '<svg class="circle" width="40" height="40" viewBox="0 0 40 40"><circle class="circle2" cx="20" cy="20" r="19" stroke="#CDCDCD" stroke-width="1" fill="none"/><circle class="circle1" cx="20" cy="20" r="19" stroke="#121212" stroke-width="1" fill="none"/></svg></span>';
                    },
                },
            },
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            // 個別にクラスをつけることができる
            renderBullet: (index, className) => {
                return '<span class="' + className + '">0' + (Number(index) + 1) + '<svg class="circle" width="34" height="34" viewBox="0 0 34 34"><circle class="circle2" cx="17" cy="17" r="16" stroke="#CDCDCD" stroke-width="1" fill="none"/><circle class="circle1" cx="17" cy="17" r="16" stroke="#121212" stroke-width="1" fill="none"/></svg></span>';
            },
        },
        //ナビゲーションボタン（矢印）表示の設定
        navigation: {
            nextEl: '.swiper-button-next', //「次へボタン」要素の指定
            prevEl: '.swiper-button-prev', //「前へボタン」要素の指定
        },

        on: {
            realIndexChange: () => {
                if (mySwiper.realIndex > 0) {
                    mySwiper.params.autoplay.delay = 4000;
                }
            },
        },
    });

    // new Swiper('.j-fvSlider', option);

}